'use client';
import styles from './important.module.css';

import Modal from '@/components/modal/modal';
import useModal from '@/components/modal/use-modal';

export default function Important() {
	const { isOpen, onOpen, onClose } = useModal();

	return (
		<>
			<div
				className={styles.important}
				onClick={() => onOpen('important-modal')}
			>
				<p className={styles.text}>
					<span style={{ fontWeight: 'bold' }}>IMPORTANT</span> - Injured
					recently? Click here NOW!
				</p>
			</div>

			<Modal
				isOpen={isOpen('important-modal')}
				onClose={() => onClose('important-modal')}
			>
				<Modal.Title>
					<div className={styles['dialog-title']}>Important</div>
				</Modal.Title>
				<Modal.Body>
					<div>
						<p className={styles['dialog-text']}>
							If you are looking for a trial for a recent injury it's important
							that you act <span className={styles.keyword}>FAST</span>.
						</p>
						<p className={styles['dialog-text']}>
							After a spinal cord injury the body undergoes continuous changes.
							Certain treatments may only work if applied at a specific time
							windows (i.e. days - weeks - months) following injury.
						</p>
						<p className={styles['dialog-text']}>
							Time windows after injury are classified by the following:
						</p>
						<ul className={styles['dialog-list']}>
							<li style={{ listStyle: 'inside', marginLeft: '1.25rem' }}>
								<span className={styles.keyword}>Acute</span> - Post-injury
								period within a few days after injury
							</li>
							<li style={{ listStyle: 'inside', marginLeft: '1.25rem' }}>
								<span className={styles.keyword}>Sub-Acute</span> - Post-injury
								period within a few weeks after injury, but possibly up to a
								couple of months
							</li>
							<li style={{ listStyle: 'inside', marginLeft: '1.25rem' }}>
								<span className={styles.keyword}>Chronic</span> - Any time after
								the sub-acute period
							</li>
						</ul>
						<p className={styles['dialog-text']}>
							The lengths of time for each of these have no standard definition.
							Different trials might use them to mean different lengths of time.
						</p>
						<p className={styles['dialog-text']}>
							If you are in the Acute or Sub-Acute range and you want to
							participate in one of these trials then you should contact the
							investigator while you are still in this period.
						</p>
						<p className={styles['dialog-text']}>
							Please use scitrials.org to find trials, but when applying please
							contact the sites and investigators directly by{' '}
							<span className={styles.keyword}>PHONE</span> for acute or
							sub-acute trials. Time is critical, so please don't rely on an
							investigator checking their email to respond to you. We have no
							ability to get them to reply to urgent requests.
						</p>
						<p className={styles['dialog-text']}>
							Also you should ask your current health care provider about the
							trial and see if they can help getting you on the trial.
						</p>
						<p className={styles['dialog-text']}>
							<span className={styles.keyword}>
								Registering and adding your profile
							</span>{' '}
							will also help you to narrow down trials. You can use your profile
							to search for trials that match the injury.
						</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						className={styles['dialog-btn']}
						onClick={() => onClose('important-modal')}
					>
						close
					</button>
				</Modal.Footer>
			</Modal>
		</>
	);
}
